export interface Response<T> {
	result: ResponseStatus;
	validationFailures: Array<ValidationFailure>;
	data: T;
}

export interface ValidationFailure {
	message: string;
	type: FailureType;
}

export enum ResponseStatus {
	VALIDATIONERROR = 0,
	EXCEPTION = 1,
	SUCCESS = 2,
	SIGNEDOUTBYSUPERVISOR = 3,
	SignInWrongEnvironment = 4
}

export enum FailureType {
	EMPTY = 0,
	NOTFOUND = 1,
	DUPLICATE = 2,
	INVALID = 3,
	SHORT = 4,
	LONG = 5,
	INUSE = 6,
	LOCKED = 7,
}

export interface SignInResult {
	isLoggedIn: boolean;
	userId: string;
	tenantId: string;
	fullName: string;
	upn: string;
	jwt: string;
	sessionExpiryTimestamp: number;
	deployments?: any;
	errorMessage?: string;
}
